'use strict';

import React from 'react'

import { formatNum } from '@root/utility'

import { bill_types } from '@Config/options'

const { moment } = window;

export default function BillRow ({ data, blank=true, fields, ...props })
{
	moment.locale('fr');

	let row_class = 'c-dashboard__row';

	return (
		<div className={ row_class }>

			<div className="c-dashboard__cell Bill-date">
				{ moment(data.date).format('DD/MM/YYYY') }
			</div>

			<div className="c-dashboard__cell Bill-name">

				<div className="c-dashboard__long-text">
					{ data.name }
				</div>

			</div>

			<div className="c-dashboard__cell Bill-number">
				{ data.text_number }
			</div>

			<div className="c-dashboard__cell Bill-type">
				{ bill_types.find(opt => opt.value === data.type)?.label }
			</div>

			<div className="c-dashboard__cell Bill-order_number">
				{ data.order_number }
			</div>

			<div className="c-dashboard__cell Bill-amount">
				{ formatNum(data.total_price, '0,0[.]00') }
				&nbsp;€
			</div>

			<div className="c-dashboard__cell Bill-amount">
				{ formatNum(data.remaining_unpaid, '0,0[.]00') }
				&nbsp;€
			</div>

			<div className="c-dashboard__cell Bill-PDF">
				<a className="c-btn c-btn--icon c-btn--ghost" target="_blank"
					rel="noreferrer" type="application/pdf"
					href={ '/PDF/facture/' + data.id }>
					<svg className="o-svg-icon o-svg-icon--PDF c-btn__icon">
						<use xlinkHref="/images/icons.svg#svg-icon-PDF"></use>
					</svg>
					PDF
				</a>
				<a className="u-link-only" target="_blank"
					rel="noreferrer" type="application/pdf"
					href={ '/PDF/facture/' + data.id }>
					<span className="u-readers-only">
						Facture
					</span>
				</a>
			</div>

		</div>
	);
}